import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';

// Async thunks for API calls
export const fetchCategories = createAsyncThunk(
  'categories/fetchCategories',
  async (_, { rejectWithValue }) => {
    try {
      const data = await apiService.getCategories();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addCategoryAsync = createAsyncThunk(
  'categories/addCategory',
  async (category, { rejectWithValue }) => {
    try {
      const data = await apiService.addCategory(category);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateCategoryAsync = createAsyncThunk(
  'categories/updateCategory',
  async ({ id, category }, { rejectWithValue }) => {
    try {
      const data = await apiService.updateCategory(id, category);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteCategoryAsync = createAsyncThunk(
  'categories/deleteCategory',
  async (id, { rejectWithValue }) => {
    try {
      await apiService.deleteCategory(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Load initial data from localStorage (for migration from old system)
const getInitialCategories = () => {
  try {
    const stored = localStorage.getItem('Categories');
    if (stored) {
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed : [];
    }
  } catch (e) {
    console.error('Error loading categories from localStorage:', e);
  }
  return [];
};

const categoriesSlice = createSlice({
  name: 'categories',
  initialState: {
    items: getInitialCategories(),
    loading: false,
    error: null,
  },
  reducers: {
    setCategories: (state, action) => {
      state.items = action.payload;
    },
    addCategory: (state, action) => {
      state.items.push(action.payload);
    },
    updateCategory: (state, action) => {
      const index = state.items.findIndex(
        cat => String(cat.id) === String(action.payload.id)
      );
      if (index !== -1) {
        state.items[index] = action.payload;
      }
    },
    deleteCategory: (state, action) => {
      state.items = state.items.filter(
        cat => String(cat.id) !== String(action.payload)
      );
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch categories
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Add category
      .addCase(addCategoryAsync.fulfilled, (state, action) => {
        state.items.push(action.payload);
      })
      // Update category
      .addCase(updateCategoryAsync.fulfilled, (state, action) => {
        const index = state.items.findIndex(
          cat => String(cat.id) === String(action.payload.id)
        );
        if (index !== -1) {
          state.items[index] = action.payload;
        }
      })
      // Delete category
      .addCase(deleteCategoryAsync.fulfilled, (state, action) => {
        state.items = state.items.filter(
          cat => String(cat.id) !== String(action.payload)
        );
      });
  },
});

export const { setCategories, addCategory, updateCategory, deleteCategory } = categoriesSlice.actions;
export default categoriesSlice.reducer;

